(() => {
  'use strict';
  const config = document.getElementById('sr-offer-config');
  if (!config) return;
  const cfg = JSON.parse(config.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const ar = document.documentElement.lang.startsWith('ar');
  const managed = new Set(['SAARIY50','SAARIY120','SAARIY225','SAARIYCABLE2','SAARIYCABLE3','SAARIYUPGRADE','SAARIYGIFT']);
  let lastCart, timer, queue = Promise.resolve();
  function paint(cart) {
    if (!cart) return;
    const remaining = Math.max(0,cfg.threshold-cart.total_price);
    const amount = new Intl.NumberFormat(ar?'ar-EG':'en-EG',{maximumFractionDigits:2}).format(remaining/100)+(ar?' جنيه':' EGP');
    document.querySelectorAll('sr-offers').forEach(panel => {
      panel.querySelector('[data-sr-offer-status]').textContent = remaining?cfg.remaining.replace('__AMOUNT__',amount):cfg.unlocked;
      panel.querySelector('[data-sr-fill]').style.width = `${Math.min(100,cart.total_price/cfg.threshold*100)}%`;
      panel.querySelector('[role=progressbar]').setAttribute('aria-valuenow',String(Math.min(cart.total_price,cfg.threshold)/100));
    });
  }
  async function request(path,data) {
    const response = await fetch(root+path,{method:data?'POST':'GET',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
    if (!response.ok) throw new Error(cfg.error);
    return response.json();
  }
  async function run() {
    let cart = await request('cart.js'), changed = false;
    const gifts = cart.items.filter(item=>item.properties?._sr_gift==='1');
    for (const line of gifts) {
      await request('cart/change.js',{id:line.key,quantity:0});
      changed=true;
    }
    if (changed) cart=await request('cart.js');
    const codes=cart.discount_codes||[];
    if(codes.some(c=>managed.has(c.code.toUpperCase())) || cart.attributes?._sr_offer) {
      cart=await request('cart/update.js',{discount:codes.filter(c=>!managed.has(c.code.toUpperCase())).map(c=>c.code).join(','),attributes:{_sr_offer:''}});
      changed=true;
    }
    lastCart=cart;paint(cart);
    if(changed)document.dispatchEvent(new CustomEvent('cart:reload'));
    return cart;
  }
  function sync(){queue=queue.catch(()=>{}).then(run);return queue;}
  window.SaariyOffers={sync};
  if(!customElements.get('sr-offers'))customElements.define('sr-offers',class extends HTMLElement{connectedCallback(){paint(lastCart);}});
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>sync().catch(()=>{}),180);}
  document.addEventListener('cart:update',schedule);
  document.addEventListener('discount:update',schedule);
  document.addEventListener('cart:drawer:render',schedule);
  document.addEventListener('cart:main:render',schedule);
  window.addEventListener('pageshow',schedule);
  let going=false;
  document.addEventListener('click',event=>{
    const button=event.target.closest('button[name=checkout],input[name=checkout],a[href$="/checkout"]');
    if(!button||going)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(button.form&&!button.form.reportValidity())return;
    going=true;button.setAttribute('aria-busy','true');
    sync().then(()=>location.assign(root+'checkout')).catch(()=>{
      going=false;button.removeAttribute('aria-busy');
      document.querySelectorAll('[data-sr-offer-status]').forEach(el=>el.textContent=cfg.error);
    });
  },true);
  function init(context=document){
    context.querySelectorAll('[data-sr-marquee]:not([data-sr-ready])').forEach(bar=>{
      bar.dataset.srReady='true';
      const button=bar.querySelector('[data-sr-marquee-pause]');
      const update=()=>{const paused=bar.dataset.paused==='true';button.textContent=paused?'▶':'Ⅱ';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?cfg.play:cfg.pause);};
      button.addEventListener('click',()=>{bar.dataset.paused=String(bar.dataset.paused!=='true');update();});update();
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('click',event=>{document.querySelectorAll('.sr-floating-language[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.sr-floating-language[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});});
  schedule();
})();
